export const S7_CODE = 'S7';
export const UTAIR_CODE = 'UT';

export const AIRLINES_WITH_CHOOSE_SEATS_AVAILABLE = [S7_CODE, UTAIR_CODE];
